import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/ratingManage',
        name: '订单评价管理',
        meta: {
            title: "订单评价管理",
        },
        redirect: '/ratingManage/ratingList',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/ratingManage/ratingList',
                name: "评价列表",
                meta: {
                    title: "评价列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/ratingManage/ratingList.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/ratingManage/ratingSetting',
                name: "评价设置",
                meta: {
                    title: "评价设置",
                    isDestroy: true
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/ratingManage/ratingSetting.vue'),
                    sidebar: Sidebar
                }
            }
        ]
    }
]